export const environment = {
  production: true,
  buildHash: 'k908u9z7zbfhsjd',
};
